module.exports = __webpack_public_path__ + "static/media/event.3bf2fc9c.svg";